import { Trans, useLingui } from '@lingui/react/macro';

import { FilterCheckboxItem } from '@/design_system/Filters/FiltersMenu/FilterCheckboxItem';
import { FiltersMenu, FiltersSubMenu } from '@/design_system/Filters/FiltersMenu/FiltersMenu';
import { FilterTag } from '@/design_system/Filters/FiltersMenu/FilterTag';
import IconStep from '@/icons/Step.svg';
import { SHIPMENT_STEPS } from '@/models/shipment';

import { useFilters } from '../FiltersState';

export const FiltersStep = ({ tag }: { tag?: boolean }) => {
  const { t, i18n } = useLingui();

  const {
    steps: { steps, setSteps },
  } = useFilters();

  const options = SHIPMENT_STEPS.map(({ id, name }) => (
    <FilterCheckboxItem
      key={id}
      checked={steps.includes(id)}
      onChange={(checked) => {
        if (checked) {
          setSteps([...steps, id]);
        } else {
          setSteps(steps.filter((type) => type !== id));
        }
      }}
    >
      {i18n._(name)}
    </FilterCheckboxItem>
  ));

  if (tag) {
    if (steps.length === 0) {
      return null;
    }

    return (
      <FiltersMenu
        button={
          <FilterTag
            label={t({ id: 'shipments.filters.step.label', message: 'Step' })}
            value={
              steps.length === 1 ? (
                i18n._(SHIPMENT_STEPS.find((type) => type.id === steps[0])!.name)
              ) : (
                <Trans id="shipments.filters.step.multiple">{steps.length} steps</Trans>
              )
            }
            tooltip={
              steps.length > 1
                ? steps
                    .map((type) => i18n._(SHIPMENT_STEPS.find((t) => t.id === type)!.name))
                    .join(', ')
                : undefined
            }
            onClear={() => setSteps([])}
          />
        }
      >
        {options}
      </FiltersMenu>
    );
  }

  return (
    <FiltersSubMenu
      icon={<IconStep />}
      label={t({ id: 'shipments.filters.step.label', message: 'Step' })}
    >
      {options}
    </FiltersSubMenu>
  );
};
